import { configureStore } from '@reduxjs/toolkit';
import { createBrowserHistory, createHashHistory } from 'history';
import { routerMiddleware } from 'connected-react-router';
import thunkMiddleware from 'redux-thunk';

import history from '../history';
import rootReducer from './rootReducer';

// export const history = createBrowserHistory();
// export const history = createHashHistory();

const middleware = [
  thunkMiddleware,
  routerMiddleware(history)
];

const Store = configureStore({
  reducer: rootReducer(history),
  middleware
});

export default Store;
